var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsHorizontalOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 8H3.34008M8.00008 8H8.00675M12.6667 8H12.6734M4.00008 8C4.00008 8.17681 3.92984 8.34638 3.80482 8.4714C3.67979 8.59643 3.51023 8.66667 3.33341 8.66667C3.1566 8.66667 2.98703 8.59643 2.86201 8.4714C2.73699 8.34638 2.66675 8.17681 2.66675 8C2.66675 7.82319 2.73699 7.65362 2.86201 7.52859C2.98703 7.40357 3.1566 7.33333 3.33341 7.33333C3.51023 7.33333 3.67979 7.40357 3.80482 7.52859C3.92984 7.65362 4.00008 7.82319 4.00008 8ZM8.66675 8C8.66675 8.17681 8.59651 8.34638 8.47149 8.4714C8.34646 8.59643 8.17689 8.66667 8.00008 8.66667C7.82327 8.66667 7.6537 8.59643 7.52868 8.4714C7.40365 8.34638 7.33341 8.17681 7.33341 8C7.33341 7.82319 7.40365 7.65362 7.52868 7.52859C7.6537 7.40357 7.82327 7.33333 8.00008 7.33333C8.17689 7.33333 8.34646 7.40357 8.47149 7.52859C8.59651 7.65362 8.66675 7.82319 8.66675 8ZM13.3334 8C13.3334 8.17681 13.2632 8.34638 13.1382 8.4714C13.0131 8.59643 12.8436 8.66667 12.6667 8.66667C12.4899 8.66667 12.3204 8.59643 12.1953 8.4714C12.0703 8.34638 12.0001 8.17681 12.0001 8C12.0001 7.82319 12.0703 7.65362 12.1953 7.52859C12.3204 7.40357 12.4899 7.33333 12.6667 7.33333C12.8436 7.33333 13.0131 7.40357 13.1382 7.52859C13.2632 7.65362 13.3334 7.82319 13.3334 8Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontalOutline);
export default __webpack_public_path__ + "static/media/DotsHorizontalOutline.965cca8073211aeeb214db62ba941f5d.svg";
export { ForwardRef as ReactComponent };